import React from 'react';
import { Provider } from 'react-redux';
// import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';

import { store } from '$src/redux/store';
// import Routes from '$src/routes';

import 'normalize.css';
import 'antd/dist/reset.css';
import './style.less';
import Assessment from './containers/Assessment';

function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#C2525E',
          colorBgContainerDisabled: '#C2525E80',
          colorTextDisabled: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 16,
          borderRadiusLG: 28,
        },
      }}
    >
      <Provider store={store}>
        <Assessment />
        {/* <BrowserRouter>
          <Routes />
        </BrowserRouter> */}
      </Provider>
    </ConfigProvider>
  );
}

export default App;
